import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NotificationFacade, ShoppingCartService } from '@ridango/components';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'gl-value-code-modal',
    templateUrl: './value-code-modal.component.html',
    styleUrls: ['./value-code-modal.component.scss']
})
export class ValueCodeModalComponent extends BaseComponent implements OnDestroy {
    @Input() cartId: number;
    public valueCode: string;

    constructor(
        private modalCtrl: ModalController,
        private shoppingCartService: ShoppingCartService,
        private notifications: NotificationFacade,
        private translate: TranslateService,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    public handleSaveClick() {
        this.shoppingCartService
            .redeemValueCode(this.cartId, this.valueCode)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                () => {
                    this.modalCtrl.dismiss(true, 'submit').then(() => {
                        this.notifications.success(this.translate.instant('CART_VALUE_CODE_REDEEMED_SUCCESSFULLY'));
                    });
                },
                (e) => {
                    let errorMessageForUI = '';
                    if (this.env.IS_NEW_AFC) {
                        let returnedErrMessage: string;
                        try {
                            const errorMsgJson = JSON.parse(e.error?.message);
                            const currentLang = this.translate.currentLang;
                            returnedErrMessage = errorMsgJson.translations?.[currentLang] || errorMsgJson.message;
                        } catch {
                            returnedErrMessage = typeof e.error?.message === 'string' ? e.error.message : '';
                        }
                        errorMessageForUI =
                            returnedErrMessage || this.translate.instant('CART_VALUE_CODE_COMMON_ERROR');
                    } else {
                        errorMessageForUI = this.translate.instant(e.error || 'CART_VALUE_CODE_COMMON_ERROR');
                    }

                    this.modalCtrl.dismiss(false, 'cancel').then(() => {
                        this.notifications.errorV2(errorMessageForUI);
                    });
                }
            );
    }

    valueCodeChange(event) {
        this.valueCode = event.target.value.toUpperCase();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
